import React from 'react';
import { useTranslation } from 'react-i18next';
import { Image, StyleSheet, View } from 'react-native';
// import axios from 'axios';
import moment from 'moment';
// import { useIAP } from 'react-native-iap';
import { useRecoilValue } from 'recoil';

import { settingsMenuTestIDs, settingsPageTestIDs, Theme } from '@constants';
// import { apiConfig } from '../../../config/apiConfig';
// import { useGetSubscriptions } from '../../../hooks/api';
// import { getUserProducts } from '../../../hooks/api/useGetUserProducts/useGetUserProducts';
import { useContextNodeHandle, useContextReference } from '@hooks';
import { screenReaderEnabledState, userSettingsState } from '@store';

import AccountSettingsQR from '../../../assets/account_QR.png';
// import { getDspAuthHeader } from '../../../util/DspAuth';
import { canManageSubscriptionsOnPlatform, canPurchaseOnPlatform, isFireTV } from '../../../helpers/Platform';
import { TWCAccessibleContent } from '../../focusable/TWCAccessibleContent/TWCAccessibleContent';
import { TWCButton } from '../../focusable/TWCButton/TWCButton';
import { TWCText } from '../../primitives/TWCText/TWCText';

// TODO: Uncomment and test for changeing subscriptions on google play

// const linkPurchase = async (purchase, retry = false) => {
//   const {
//     purchaseToken,
//     transactionReceipt,
//     userIdAmazon,
//     userMarketplaceAmazon,
//   } = purchase;

//   const { sku, purchaseDate } = JSON.parse(transactionReceipt);
//   const dspBody = {
//     orderId: purchaseToken,
//     packageName: `com.weathergroup.twc`,
//     productId: sku,
//     purchaseTime: purchaseDate,
//     purchaseState: `SUCCESSFUL`,
//     purchaseToken,
//     autoRenewing: {
//       userId: userIdAmazon,
//       marketplace: userMarketplaceAmazon,
//     },
//     signature: JSON.parse(transactionReceipt),
//   };

//   const headers = await getDspAuthHeader(retry);
//   try {
//     const { status } = await axios.post(
//       apiConfig.AMAZON_LINK_PURCHASE_URL,
//       dspBody,
//       { headers },
//     );
//     if (status === 409 || (status >= 200 && status < 300)) {
//       return;
//     } else {
//       throw new Error(`Error linking purchase`);
//     }
//   } catch (error) {
//     console.error(error);
//     if (!retry) {
//       linkPurchase(purchase, true);
//     } else {
//       throw error;
//     }
//   }
// };

// const refreshProducts = async (
//   retry = false,
//   userSettings,
//   setUserSettings,
// ) => {
//   try {
//     const headers = await getDspAuthHeader(retry);
//     const { products } = await getUserProducts(headers);
//     if (products.svod.length > 0) {
//       const {
//         customer,
//         product,
//         next_assessment_at,
//         trial_started_at,
//         state,
//         previous_state,
//       } = products.svod[0];
//       const newSettings = {
//         ...userSettings,
//         firstName: customer.first_name,
//         lastName: customer.last_name,
//         email: customer.email,
//         pricePlan: product.name,
//         billDate: next_assessment_at,
//         trialStart: trial_started_at,
//         subscriptionStatus: state,
//         priorSubscriptionStatus: previous_state,
//         dspCustomerId: customer.id,
//         isPaidSubscriber: true,
//       };
//       setUserSettings(newSettings);
//       const isValid = state === `active` || state === `trialing`;
//       if (isValid) {
//         return { success: true };
//       } else {
//         throw new Error(
//           `Could not get valid user subscription after updating subscription.`,
//         );
//       }
//     }
//   } catch (productsError) {
//     if (productsError.response) {
//       console.log(productsError);
//       // if this our first time through, and the status is 403, meaning expired token,
//       // so retry (which will force a new token)
//       const { status } = productsError.response;
//       if (!retry && status === 403) {
//         refreshProducts(true);
//       } else {
//         throw new Error(`Unknown error fetching user products.`);
//       }
//     }
//   }
// };

// const changeSubscriptionPlan = async (subscriptions, currentPlan, iap) => {
//   // Quick exit if not purchasing
//   if (!subscriptions || !currentPlan) {
//     return;
//   }

//   // Assumption of only two plans
//   const filteredSubs = subscriptions.filter(
//     (subItem) => subItem.productId !== currentPlan,
//   );

//   if (filteredSubs?.length === 0) {
//     return { error: `No valid subscriptions to change to` };
//   }

//   const newSub = filteredSubs[0];

//   const { currentPurchase, requestSubscription, finishTransaction } = iap;

//   if (currentPurchase) {
//     try {
//       await finishTransaction(currentPurchase, false);
//       await linkPurchase(currentPurchase);
//       return { success: true };
//     } catch (error) {
//       console.error(error);
//       return { error: error.message };
//     }
//   } else {
//     try {
//       console.log(`requesting subscription: ${newSub.productId}`);
//       await requestSubscription(newSub.productId, false, currentPlan, 0);
//       return;
//     } catch (error) {
//       console.error(error);
//       return { error: error.message };
//     }
//   }
// };

const tPath = 'settingsPage.account';

export const SettingsAccount = () => {
  const userSettings = useRecoilValue(userSettingsState);

  const { cableProviderName, isPaidSubscriber, firstName, lastName, pricePlan, billDate, subscriptionPlatform } =
    userSettings;
  const { t } = useTranslation('translation', { keyPrefix: tPath });
  const m = moment(billDate);

  const accountMenuReference = useContextReference(settingsMenuTestIDs.account);
  const accountMenuHandle = useContextNodeHandle(settingsMenuTestIDs.account);

  const screenReaderEnabled = useRecoilValue(screenReaderEnabledState);

  const accountInfoHandle = useContextNodeHandle(settingsPageTestIDs.account.settingsAccountInfo);
  const accountHelpHandle = useContextNodeHandle(settingsPageTestIDs.account.settingsAccountHelpSection);
  const accountChangeButtonHandle = useContextNodeHandle(settingsPageTestIDs.account.settingsAccountChangePlanButton);

  // TODO: Uncomment and test for changing subscriptions on google play

  // const { data: subscriptions } = useGetSubscriptions();
  // const iap = useIAP();
  // const [upgradePlan, setUpgradePlan] = useState(null);
  // const [shouldRefreshProducts, setRefetchProducts] = useState(false);

  // useEffect(() => {
  //   changeSubscriptionPlan(subscriptions, upgradePlan, iap)
  //     .then(({ success, error }) => {
  //       if (success || error) {
  //         setUpgradePlan(null);
  //       }
  //       if (success) {
  //         setRefetchProducts(true);
  //       }
  //     })
  //     .catch((error) => {
  //       // TODO: Show error to user?
  //       setUpgradePlan(null);
  //     });
  // }, [subscriptions, upgradePlan, iap]);

  // useEffect(() => {
  //   if (shouldRefreshProducts) {
  //     refreshProducts(false, userSettings, setUserSettings).then(
  //       ({ success, error }) => {
  //         if (success) {
  //           setRefetchProducts(false);
  //         } else {
  //           // TODO: Show to user?
  //           console.warn(
  //             `Unable to refresh user account subscription details.`,
  //           );
  //         }
  //       },
  //     );
  //   }
  // }, [shouldRefreshProducts, userSettings, setUserSettings]);

  return isPaidSubscriber ? (
    <View style={styles.settingsAccountWrapper}>
      <TWCAccessibleContent
        disabledScreenreaderFocus={accountMenuReference}
        nativeID={settingsPageTestIDs.account.settingsAccountInfo}
        nextFocusDown={canManageSubscriptionsOnPlatform ? accountChangeButtonHandle : accountHelpHandle}
        nextFocusLeft={accountMenuHandle}
        nextFocusRight={null}
        nextFocusUp={null}
        testID={settingsPageTestIDs.account.settingsAccountInfo}
      >
        <View style={styles.settingsAccountTopContent}>
          <View collapsable importantForAccessibility={'no'} style={styles.settingsAccountTopContentItem}>
            <TWCText noTestID variant={'boldText30'}>
              {t('first')}
            </TWCText>
            <TWCText noTestID variant={'regularText30'}>
              {firstName}
            </TWCText>
          </View>
          <View collapsable importantForAccessibility={'no'} style={styles.settingsAccountTopContentItem}>
            <TWCText noTestID variant={'boldText30'}>
              {t('last')}
            </TWCText>
            <TWCText noTestID variant={'regularText30'}>
              {lastName}
            </TWCText>
          </View>
          <View collapsable importantForAccessibility={'no'} style={styles.settingsAccountTopContentItem}>
            <TWCText noTestID variant={'boldText30'}>
              {t('billingDate')}
            </TWCText>
            <TWCText noTestID variant={'regularText30'}>
              {m.format('MMMM Do YYYY')}
            </TWCText>
          </View>
          <View collapsable importantForAccessibility={'no'} style={styles.settingsAccountTopContentItem}>
            <TWCText noTestID variant={'boldText30'}>
              {t('pricePlan')}
            </TWCText>
            <TWCText noTestID variant={'regularText30'}>
              {pricePlan ? t(pricePlan) : t('pricePlanError')}
            </TWCText>
          </View>
        </View>
      </TWCAccessibleContent>
      <View>
        {canPurchaseOnPlatform ? (
          <>
            {canManageSubscriptionsOnPlatform && ( // can not change subscriptions on amazon fire
              <TWCButton
                disabled={!pricePlan}
                nextFocusLeft={accountMenuHandle}
                nextFocusRight={null}
                nextFocusUp={screenReaderEnabled ? accountInfoHandle : null}
                nextFousDown={screenReaderEnabled ? accountHelpHandle : null}
                testID={settingsPageTestIDs.account.settingsAccountChangePlanButton}
                title={pricePlan ? t(`changeSubscription.${pricePlan}`) : t('pricePlanError')}
                onPress={() => {
                  console.log(`change plan: ${pricePlan}`);
                  // setUpgradePlan(pricePlan);
                }}
              />
            )}
            <TWCAccessibleContent
              disabledScreenreaderFocus={accountMenuReference}
              nativeID={settingsPageTestIDs.account.settingsAccountHelpSection}
              nextFocusDown={null}
              nextFocusLeft={accountMenuHandle}
              nextFocusRight={null}
              nextFocusUp={canManageSubscriptionsOnPlatform ? accountChangeButtonHandle : accountInfoHandle}
              testID={settingsPageTestIDs.account.settingsAccountHelpSection}
            >
              <TWCText noTestID variant={'regularText36'}>
                {t('purchaseChanges', {
                  account: isFireTV && subscriptionPlatform === 'amazon_fire' ? 'Amazon' : 'Online', // TODO: Handle roku/google play subs?
                })}
              </TWCText>
            </TWCAccessibleContent>
          </>
        ) : (
          <TWCAccessibleContent
            disabledScreenreaderFocus={accountMenuReference}
            nativeID={settingsPageTestIDs.account.settingsAccountHelpSection}
            nextFocusDown={null}
            nextFocusLeft={accountMenuHandle}
            nextFocusRight={null}
            nextFocusUp={accountInfoHandle}
            testID={settingsPageTestIDs.account.settingsAccountHelpSection}
          >
            <>
              <TWCText noTestID variant={'regularText36'}>
                {t('changes')}
              </TWCText>
              <TWCText
                noTestID
                accessibilityHint={''}
                accessibilityLabel={t('streamAccessibleURL')}
                variant={'regularText42Transparent'}
              >
                {t('streamURL')}
              </TWCText>
              <Image source={AccountSettingsQR} style={styles.QRImage} />
            </>
          </TWCAccessibleContent>
        )}
      </View>
    </View>
  ) : (
    <View style={styles.cableSettingsAccountWrapper}>
      <TWCAccessibleContent
        disabledScreenreaderFocus={accountMenuReference}
        nativeID={settingsPageTestIDs.account.settingsAccountInfo}
        nextFocusDown={null}
        nextFocusLeft={accountMenuHandle}
        nextFocusRight={null}
        nextFocusUp={null}
        testID={settingsPageTestIDs.account.settingsAccountInfo}
      >
        <View>
          <TWCText noTestID variant={'regularText36'}>
            {t('cableAccountText')}
          </TWCText>
          <TWCText noTestID variant={'regularText42Transparent'}>
            {cableProviderName}
          </TWCText>
        </View>
      </TWCAccessibleContent>
    </View>
  );
};

const styles = StyleSheet.create({
  QRImage: {
    height: Theme.px(300),
    marginTop: Theme.px(65),
    width: Theme.px(300),
  },
  cableSettingsAccountWrapper: {
    paddingTop: Theme.px(311),
  },
  settingsAccountProvider: {
    lineHeight: Theme.px(62),
  },
  settingsAccountText: {
    lineHeight: Theme.px(48),
  },
  settingsAccountTopContent: {
    paddingBottom: Theme.px(66),
  },
  settingsAccountTopContentItem: {
    flexDirection: 'row',
  },
  settingsAccountWrapper: {
    paddingTop: Theme.px(318),
  },
});
